import React from "react";

interface SpinnerIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const SpinnerIcon: React.FC<SpinnerIconProps> = ({
  width = 20,
  height = 20,
  className = "",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 12a9 9 0 11-6.219-8.56" />
    </svg>
  );
};
